var map = {
	"./cake.webp": 1977,
	"./crown-blue.webp": 1978,
	"./crown.webp": 1979,
	"./pocket.webp": 1980,
	"./present.webp": 1981,
	"./relegation.webp": 1982,
	"./t-deposit.webp": 1983,
	"./t-turnover.webp": 1984,
	"./vip-bg.webp": 1985,
	"./vip1.gif": 1986,
	"./vip1.webp": 1987,
	"./vip10-bg.webp": 1988,
	"./vip10.gif": 1989,
	"./vip10.webp": 1990,
	"./vip11-bg.webp": 1991,
	"./vip11.gif": 1992,
	"./vip11.webp": 1993,
	"./vip12-bg.webp": 1994,
	"./vip12.gif": 1995,
	"./vip12.webp": 1996,
	"./vip2.gif": 1997,
	"./vip2.webp": 1998,
	"./vip3.gif": 1999,
	"./vip3.webp": 2000,
	"./vip4.gif": 2001,
	"./vip4.webp": 2002,
	"./vip5.gif": 2003,
	"./vip5.webp": 2004,
	"./vip6.gif": 2005,
	"./vip6.webp": 2006,
	"./vip7.gif": 2007,
	"./vip7.webp": 2008,
	"./vip8.gif": 2009,
	"./vip8.webp": 2010,
	"./vip9.gif": 2011,
	"./vip9.webp": 2012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 475;